// @ts-nocheck
import React from "react";
import InfoPageLayout, { InfoSection, InfoList } from "../components/InfoPageLayout";

export default function ChildSafety() {
  return (
    <InfoPageLayout
      title="Child Safety Standards"
      subtitle="Our standards against child sexual abuse and exploitation (CSAE)."
      updated="August 5, 2026"
    >
      <InfoSection title="Our Commitment">
        <p>
          Cardex has zero tolerance for child sexual abuse and exploitation (CSAE). We prohibit any
          content, conduct, or communication that sexualises, endangers, or exploits a minor, and we
          act on every report we receive.
        </p>
        <p>
          These standards apply to every part of Cardex — listings, bounties, trades, messages,
          profiles, images, and in-person meetups arranged through the platform.
        </p>
      </InfoSection>

      <InfoSection title="1. Adults-Only Platform">
        <p>
          <strong>Cardex is restricted to users aged 18 and over.</strong> The platform facilitates
          in-person meetups between strangers, which requires adult judgment and responsibility.
        </p>
        <p>
          If we determine that an account belongs to a minor, the account is terminated immediately
          and its content removed.
        </p>
      </InfoSection>

      <InfoSection title="2. Prohibited Conduct">
        <p>The following are strictly forbidden and result in immediate, permanent removal:</p>
        <InfoList items={[
          "Child sexual abuse material (CSAM) in any form, including drawn, generated, or edited imagery",
          "Sexualisation of minors in images, listings, descriptions, usernames, or messages",
          "Grooming, solicitation, or any attempt to arrange contact with a minor",
          "Sextortion, or trading in sexualised content involving minors",
          "Trafficking, or advertising access to a minor",
          "Links or references directing users to CSAE material hosted elsewhere"
        ]} />
      </InfoSection>

      <InfoSection title="3. Reporting CSAE">
        <p>
          Any user can report suspected CSAE from inside the app. Reports are prioritised above all
          other report types.
        </p>
        <InfoList items={[
          "Open Account & Safety from the menu, then select Report Abuse",
          "Report a specific user, listing, or message directly from that item",
          "Block a user from their profile to stop all further contact",
          "Email us at support@cardexhq.com if you cannot access your account"
        ]} />
        <p>
          You do not need to be certain to report. If something feels wrong, report it and let our
          team review it.
        </p>
      </InfoSection>

      <InfoSection title="4. How We Respond">
        <p>When a CSAE report is received:</p>
        <InfoList items={[
          "The report is escalated for human review as a priority",
          "Offending content is removed and the account is suspended pending review",
          "Confirmed violations result in permanent account termination",
          "Confirmed CSAM is reported to the National Center for Missing & Exploited Children (NCMEC) and, where applicable, to local law enforcement",
          "We preserve relevant records as required by law to support investigations"
        ]} />
      </InfoSection>

      <InfoSection title="5. Prevention">
        <InfoList items={[
          "Age restriction of 18+ enforced at signup and on discovery",
          "User reporting and blocking available throughout the app",
          "Human review of reported accounts, listings, images, and messages",
          "Enforcement history retained so removed users can be identified on re-registration"
        ]} />
      </InfoSection>

      <InfoSection title="6. Legal Compliance">
        <p>
          We comply with applicable child protection laws in the jurisdictions where Cardex operates,
          including reporting obligations for suspected CSAM. Where local law imposes stricter
          requirements than these standards, the stricter requirement applies.
        </p>
      </InfoSection>

      <InfoSection title="7. Point of Contact">
        <p>
          Child safety concerns, regulator enquiries, and law enforcement requests can be sent to our
          designated contact:
        </p>
        <p className="info-contact">
          <strong>support@cardexhq.com</strong>
        </p>
        <p>
          To report child sexual exploitation directly in the United States, contact the NCMEC
          CyberTipline at report.cybertip.org or 1-800-843-5678. If a child is in immediate danger,
          contact your local emergency services first.
        </p>
      </InfoSection>
    </InfoPageLayout>
  );
}
